import CheckCircle from "@endya-conformite/ui-kit/src/assets/icons/check-circle-fill.svg?react";
import DotCircle from "@endya-conformite/ui-kit/src/assets/icons/dots-circle-outline.svg?react";
import ExclamationCircle from "@endya-conformite/ui-kit/src/assets/icons/exclamation-circle-fill.svg?react";
import XCircle from "@endya-conformite/ui-kit/src/assets/icons/x-circle-fill.svg?react";
import { RemediationStatus } from "@src/helper/remediation.helper";
import classNames from "classnames";
import styles from "./AxeStatusIcon.module.scss";

type AxeStatusIconProps = {
  status: RemediationStatus;
  className?: string;
};

export function AxeStatusIcon({ status, className }: AxeStatusIconProps) {
  switch (status) {
    case "NON":
      return <CheckCircle className={classNames(styles.non, className)} />;
    case "OUI":
      return <XCircle className={classNames(styles.oui, className)} />;
    case "MANQUANT":
      return (
        <ExclamationCircle className={classNames(styles.manquant, className)} />
      );
    case "NON_SELECTIONNE":
    default:
      return (
        <DotCircle className={classNames(styles.nonSelectionne, className)} />
      );
  }
}
